import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid px-xxl-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_ResponsiveNavbar = _resolveComponent("ResponsiveNavbar")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_CategoryWrap = _resolveComponent("CategoryWrap")!
  const _component_BrowseAllProducts = _resolveComponent("BrowseAllProducts")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_ResponsiveNavbar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MainBanner),
      _createVNode(_component_CategoryWrap),
      _createVNode(_component_BrowseAllProducts),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}